<script>

import Fa from 'svelte-fa'
import {
    faHome,
    faUserCircle,
    faPeopleGroup,
    faGifts,
    faMailReply,
    faBatteryEmpty,
    faTicket,
    faNewspaper, faHistory, faUsers, faUsersViewfinder, faTrophy,
    faBan, faHeadset, faRobot

} from '@fortawesome/free-solid-svg-icons'
import {CurrentWindow, SendDownloadExcelRequest, SendRequest} from "./APIService";
import { saveAs } from 'file-saver';

// Name of the button, Icon, WindowName
let buttons = [
    ["Find User", faUserCircle, "SearchUserWindow"],
    ["Find Multiple Users", faUsers, "FindMultipleUsers"],
    ["Clan", faPeopleGroup, "ClanWindow"],
    ["Gift Code", faGifts, "GiftCode"],
    ["PurchaseToken", faTicket, "PurchaseTokenWindow"],
    ["Reports", faMailReply, "GetReports"],
    ["DeleteReports", faBatteryEmpty, "DeleteReports"],
    ["PublicNews", faNewspaper, "PublicNews"],
    ["History", faHistory, "HistoryWindow"],
    ["WeeklyStats", faPeopleGroup, "WeeklyStatsWindow"],
    // ["UserParallels", faMailReply, "GetUserParallels"],
    // ["DeleteUserParallels", faBatteryEmpty, "DeleteUserParallels"],
    ["TopClanTournaments", faTrophy, "ExportTopClanTournamentExcel"],
    ["User Parallels", faUsersViewfinder, "GetUserParallels"],
    ["Export FunFair", faUsersViewfinder, "ExportFunFairWindow"],
    ["Chat Ban", faBan, "ChatBan"],
    ["Reconnect Ban", faBan, "ReconnectBan"],
    ["CRM Panel", faHeadset, "CRMWindow"],
    ["CRM Ready Answers", faHeadset, "CRMReadyAnswers"],
    ["CRM AI Drafts", faRobot, "CRMAiDrafts"],
]



export function downloadViolations(){
    SendRequest("GetViolationReports", 'POST',
        "", (data) => {

            let blob = new Blob([JSON.stringify(data, null, '\t')], {
                type: "text/plain;charset=utf-8;",
            });
            saveAs(blob, "Violations.txt");
        }
    );
}

export function downloadExcelViolations() {
    SendDownloadExcelRequest("GetExcelViolationReports", "GET", "Violations")
}


export function removeViolations(){
    let confirmAction = confirm("Are you sure to remove all violations from database?");
    if (confirmAction) {
        SendRequest("RemoveViolationReports", 'POST',
            "", () => {
                alert("Violations Removed");
            }
        );
    } else {
        //alert("Action canceled");
    }

}

// export function downloadExcelUserParallels() {
//     SendDownloadExcelRequest("GetExcelUserParallels", "GET", "UserParallels")
// }

// export function removeUserParallels(){
//     let confirmAction = confirm("Are you sure to remove all User Parallels from database?");
//     if (confirmAction) {
//         SendRequest("RemoveUserParallels", 'POST',
//             "", () => {
//                 alert("User Parallels Removed");
//             }
//         );
//     } else {
//         //alert("Action canceled");
//     }
// }

export function DownloadTopClanTournamentExcel() {
    SendDownloadExcelRequest("ExportTopClanTournamentExcel", "GET", "TopClanTournaments")
}

function ButtonClick(input){
    // window.history.pushState(null, null, input);
    // window.location = "#"+ input;
    if (input === "GetReports"){
        // downloadViolations();
        downloadExcelViolations();

        return;
    }
    if (input === "DeleteReports"){
        removeViolations();
        return;
    }

    if (input === "ExportTopClanTournamentExcel"){
        DownloadTopClanTournamentExcel();
        return;
    }

    CurrentWindow.set(input);
}


</script>


<div class="row">

<!--    <div class="btn-group gap-4 col-6 mx-auto">-->

        {#each buttons as btn, index}

            {#if index == 0}
                <div class="w-100"></div>
                <div class="col-md-2" ></div>
            {:else if index % 3 == 0}
                <div class="col-md-2" ></div>
                <div class="w-100"></div>
                <div class="col-md-2" ></div>
            {/if}
                    <div class="col-md-2 text-center box">
                        <div class="btn-group-vertical">
                            <div  class="button-64" role="button"  on:click={() => ButtonClick(btn[2])}>
                                <span class="btn-group-vertical gap-3">
                                    <Fa icon={btn[1]} />
                                    <div class="align-self-center">{btn[0]}</div>
                                </span>
                            </div>
                        </div>
                    </div>

        {/each}



</div>

<style>

    .box{
        margin: 20px;
    }
    .row{
        margin-top: 5%;
    }

    .gap{
        gap:3rem!important
    }
    /* CSS */
    .button-64 {
        align-items: center;
        background-image: url("/Images/button.png");
        background-repeat: no-repeat;
        background-size: 100%; /* To fill the dimensions of container (button), or */
        /*background-size: 200px auto;*/
        filter: drop-shadow(2px 2px 3px #000000);
        border: 0;
        height: 250px;
        width: 250px;
        border-radius: 8px;
        box-sizing: border-box;
        color: #d5d5d5;
        display: flex;
        font-size: 20px;
        justify-content: center;
        line-height: 1em;
        max-width: 100%;
        min-width: 140px;
        padding: 3px;
        text-decoration: none;
        user-select: none;
        -webkit-user-select: none;
        touch-action: manipulation;
        white-space: nowrap;
        cursor: pointer;
    }

    .button-64:active,
    .button-64:hover {
        outline: 0;
    }

    .button-64 span {
        /*background-color: rgb(5, 6, 45);*/
        padding: 16px 24px;
        border-radius: 6px;
        font-size: 130px;
        width: 70%;
        height: 70%;
        transition: 300ms;
        text-shadow: 2px 2px 4px #000000;
    }

    .button-64 span div{
        font-size: 20px;
    }

    .button-64:hover span {
        color: #0f1218;
    }

    @media (min-width: 768px) {
        .button-64 {
            font-size: 24px;
            min-width: 196px;
        }
    }
</style>

